export default {
    "production": "Production",
}
